import React from 'react'
import { FormattedMessage } from 'react-intl'

const NoQuestsAssignedToYou = () => (
  <div className="no-assignments">
    <div className="assignment-flag"></div>
    <div className="top">
      <div className="arrow"></div>
      <div className="smiley"></div>
      <h3>
        <FormattedMessage
          id={'NoAssignments'}
          defaultMessage={'No quests are assigned to you right now.'}
        />
      </h3>
    </div>
  </div>
)

export default NoQuestsAssignedToYou



// WEBPACK FOOTER //
// ./src/components/mini/NoQuestsAssignedToYou.js